import { create } from "../../../../../common/utils/zustand_state_manager";
import { SetFunction, SetFunctionImpl } from "../../../../../common/utils/filters_utils";
import { CargoDropDown } from "../../../../../common/domain/models/cargo_dropdown";
import { CentroCustoDropDown } from "../../../../../common/domain/models/centro_custo_dropdown";
import { FuncionarioSetorDropDown } from "../../../domain/models/funcionario_setor_dropdown";
import { FuncionarioNomeDropDown } from "../../../domain/models/funcionario_nome_dropdown";
import { FuncionarioFilialDropDown } from "../../../domain/models/funcionario_filial_dropdown";
import { TreinamentoDropDown } from "../../../domain/models/treinamento_dropdown";

/**
 * useFilters
 */

type State = {
  tipoPesquisa: number,
  pesquisa: string,
  setor: string,
  filial: string,
  admissaoDe: string,
  admissaoAte: string,
  demissaoDe: string,
  demissaoAte: string,
  afastamentoDe: string,
  afastamentoAte: string,
  feriasDe: string,
  feriasAte: string,
  centroDeCusto: number[],
  status: number,
  treinamentos: number,
  prazoExperiencia: number,
  documentos: number,
  centroDeCustoLista: CentroCustoDropDown[] | undefined,
  cargoLista: CargoDropDown[] | undefined,
  funcionarioSetoresLista: FuncionarioSetorDropDown[] | undefined,
  funcionarioNomesLista: FuncionarioNomeDropDown[] | undefined,
  funcionarioFiliaisLista: FuncionarioFilialDropDown[] | undefined,
  treinamentosDropdown: TreinamentoDropDown[] | undefined,
};

type Actions = {
  setTipoPesquisa: SetFunction<number>,
  setPesquisa: SetFunction<string>,
  setSetor: SetFunction<string>,
  setFilial: SetFunction<string>,
  setAdmissaoDe: SetFunction<string>,
  setAdmissaoAte: SetFunction<string>,
  setDemissaoDe: SetFunction<string>,
  setDemissaoAte: SetFunction<string>,
  setAfastamentoDe: SetFunction<string>,
  setAfastamentoAte: SetFunction<string>,
  setFeriasDe: SetFunction<string>,
  setFeriasAte: SetFunction<string>,
  setCentroDeCusto: SetFunction<number[]>,
  setStatus: SetFunction<number>,
  setCentroDeCustoLista: SetFunction<CentroCustoDropDown[]>,
  setCargoLista: SetFunction<CargoDropDown[]>,
  setFuncionarioSetoresLista: SetFunction<FuncionarioSetorDropDown[]>,
  setFuncionarioNomesLista: SetFunction<FuncionarioNomeDropDown[]>,
  setFuncionarioFiliaisLista: SetFunction<FuncionarioFilialDropDown[]>,
  setTreinamentosDropdown: SetFunction<TreinamentoDropDown[]>,
  clear: () => void,
};

export const initialFuncionariosListaFiltersState: Partial<State> = {
  tipoPesquisa: 0,
  pesquisa: "",
  setor: "",
  filial: "",
  admissaoDe: "",
  admissaoAte: "",
  demissaoDe: "",
  demissaoAte: "",
  afastamentoDe: "",
  afastamentoAte: "",
  feriasDe: "",
  feriasAte: "",
  centroDeCusto: [],
  status: 1,
  treinamentos: 0,
  prazoExperiencia: 0,
  documentos: 0,
};

export const useFuncionariosListaFilters = create<State & Actions>((set) => ({
  tipoPesquisa: 0,
  pesquisa: "",
  setor: "",
  filial: "",
  admissaoDe: "",
  admissaoAte: "",
  demissaoDe: "",
  demissaoAte: "",
  afastamentoDe: "",
  afastamentoAte: "",
  feriasDe: "",
  feriasAte: "",
  centroDeCusto: [],
  status: 1,
  treinamentos: 0,
  prazoExperiencia: 0,
  documentos: 0,
  centroDeCustoLista: undefined,
  cargoLista: undefined,
  funcionarioSetoresLista: undefined,
  funcionarioNomesLista: undefined,
  funcionarioFiliaisLista: undefined,
  treinamentosDropdown: undefined,
  setTipoPesquisa: (vfn) => SetFunctionImpl(set, 'tipoPesquisa', vfn),
  setPesquisa: (vfn) => SetFunctionImpl(set, 'pesquisa', vfn),
  setSetor: (vfn) => SetFunctionImpl(set, 'setor', vfn),
  setFilial: (vfn) => SetFunctionImpl(set, 'filial', vfn),
  setAdmissaoDe: (vfn) => SetFunctionImpl(set, 'admissaoDe', vfn),
  setAdmissaoAte: (vfn) => SetFunctionImpl(set, 'admissaoAte', vfn),
  setDemissaoDe: (vfn) => SetFunctionImpl(set, 'demissaoDe', vfn),
  setDemissaoAte: (vfn) => SetFunctionImpl(set, 'demissaoAte', vfn),
  setAfastamentoDe: (vfn) => SetFunctionImpl(set, 'afastamentoDe', vfn),
  setAfastamentoAte: (vfn) => SetFunctionImpl(set, 'afastamentoAte', vfn),
  setFeriasDe: (vfn) => SetFunctionImpl(set, 'feriasDe', vfn),
  setFeriasAte: (vfn) => SetFunctionImpl(set, 'feriasAte', vfn),
  setCentroDeCusto: (vfn) => SetFunctionImpl(set, 'centroDeCusto', vfn),
  setStatus: (vfn) => SetFunctionImpl(set, 'status', vfn),
  setCentroDeCustoLista: (vfn) => SetFunctionImpl(set, 'centroDeCustoLista', vfn),
  setCargoLista: (vfn) => SetFunctionImpl(set, 'cargoLista', vfn),
  setFuncionarioSetoresLista: (vfn) => SetFunctionImpl(set, 'funcionarioSetoresLista', vfn),
  setFuncionarioNomesLista: (vfn) => SetFunctionImpl(set, 'funcionarioNomesLista', vfn),
  setFuncionarioFiliaisLista: (vfn) => SetFunctionImpl(set, 'funcionarioFiliaisLista', vfn),
  setTreinamentosDropdown: (vfn) => SetFunctionImpl(set, 'treinamentosDropdown', vfn),
  clear: () => set({ ...initialFuncionariosListaFiltersState }),
}));

